<template>
  <LISAInput v-model.number="numberOfDays" type="number" hide-label :label="t('global.days')">
    <template #append>{{ t("global.days") }}</template>
  </LISAInput>
</template>

<script setup lang="ts">
import { LISAInput } from "@fi-solutions/lisa-ui";
import { ref } from "vue";
import { useTranslation } from "@/language/translation";
import RecentlyChangedFilter from "../filterImplementations/RecentlyChangedFilter";

defineOptions({
  inheritAttrs: false,
});
const { t } = useTranslation();
const numberOfDays = ref<number>();
const includeActionChanges = ref(false);

function getFilter() {
  return numberOfDays.value == null
    ? null
    : new RecentlyChangedFilter(numberOfDays.value * 24, undefined, includeActionChanges.value);
}
function applyFilter(filter: RecentlyChangedFilter) {
  includeActionChanges.value = filter.includeActionChanges;
  numberOfDays.value = filter.definitionOfRecentInHours / 24;
}
defineExpose({
  getFilter,
  applyFilter,
});
</script>
